import url from 'url';
import cookie from 'js-cookie';
import { ACTION_PREFIX } from '../../constants';
import { dataURLtoBlob, getCarrierAndPlan } from './ScanCardActionsHelpers';
import {
    chooseCarrier,
    choosePlan,
    closeDropdown,
    closeScanCard,
    setShowScanCardErrorModal,
    setScanCardAttempted,
} from '../../data/dropdown-state/dropdownStateActions';
import { getScanCardState } from '../../data/scan-card/scanCardSelector';
import invariant from 'invariant';
import dropdownStateSelector from '../../data/dropdown-state/dropdownStateSelector';
import { AnalyticsTypes } from '../../../utils';

export const REQUEST_SCAN_CARD = `${ACTION_PREFIX}/REQUEST_SCAN_CARD`;
export const REQUEST_SCAN_CARD_SUCCEEDED = `${ACTION_PREFIX}/REQUEST_SCAN_CARD_SUCCEEDED`;
export const REQUEST_SCAN_CARD_FAILED = `${ACTION_PREFIX}/REQUEST_SCAN_CARD_FAILED`;
export const REQUEST_SCAN_CARD_CANCELLED = `${ACTION_PREFIX}/REQUEST_SCAN_CARD_CANCELLED`;
export const REQUEST_SCAN_CARD_DONE = `${ACTION_PREFIX}/REQUEST_SCAN_CARD_DONE`;
export const SCAN_CARD_CHOOSE_CARRIER = `${ACTION_PREFIX}/SCAN_CARD_CHOOSE_CARRIER`;
export const SCAN_CARD_CHOOSE_PLAN = `${ACTION_PREFIX}/SCAN_CARD_CHOOSE_PLAN`;
export const SCAN_CARD_REPICK_CARRIER = `${ACTION_PREFIX}/SCAN_CARD_REPICK_CARRIER`;
export const PRIVACY_CHECKBOX_CLICKED = `${ACTION_PREFIX}/PRIVACY_CHECKBOX_CLICKED`;
export const PRIVACY_DIALOG_DISMISS = `${ACTION_PREFIX}/PRIVACY_DIALOG_DISMISS`;
export const RECORD_NUMBER_OF_CARRIERS_DISPLAYED = `${ACTION_PREFIX}/RECORD_NUMBER_OF_CARRIERS_DISPLAYED`;
export const RECORD_NUMBER_OF_PLANS_DISPLAYED = `${ACTION_PREFIX}/RECORD_NUMBER_OF_PLANS_DISPLAYED`;
export const SCAN_CARD_CAPTURED_FRONT_CARD = `${ACTION_PREFIX}/SCAN_CARD_CAPTURED_FRONT_CARD`;
export const EDIT_SCAN_CARD_CARRIER = `${ACTION_PREFIX}/EDIT_SCAN_CARD_CARRIER`;
export const EDIT_SCAN_CARD_PLAN = `${ACTION_PREFIX}/EDIT_SCAN_CARD_PLAN`;
export const CANCEL_EDIT_SCAN_CARD = `${ACTION_PREFIX}/CANCEL_EDIT_SCAN_CARD`;
export const SCAN_CARD_PLAN_SELECTED_V2 = `${ACTION_PREFIX}/SCAN_CARD_PLAN_SELECTED_V2`;


export const I_DONT_SEE_MY_PLAN = '-1';
export const I_DONT_SEE_MY_CARRIER = '-1';

function getCleardataApiUrl(state) {
    const dropdownState = dropdownStateSelector(state);
    const API_2_URL = url.parse(process.env.CLEARDATA_API_HOST || dropdownState.CLEARDATA_API_HOST || '');
    return API_2_URL;
}

function getApiUrl(state) {
    const dropdownState = dropdownStateSelector(state);
    const API_URL = url.parse(process.env.AWS_API_HOST || dropdownState.AWS_API_HOST || '');
    return API_URL;
}

function requestScanCard(imageFront) {
    return {
        type: REQUEST_SCAN_CARD,
        payload: {
            imageFront,
        },
    };
}
export function fetchScanCard(imageFront, imageBack) {
    return (dispatch, getState) => {
        dispatch(requestScanCard(imageFront));
        dispatch(setScanCardAttempted());
        const state = getState();
        const apiUrl = getCleardataApiUrl(state);
        const cardState = getScanCardState(state);
        const acceptedUserAgreement = cardState.isPrivacyPolicyCheckboxChecked;

        const formData = new FormData();

        formData.append('card_image_front', dataURLtoBlob(imageFront));
        formData.append('accepted_terms_of_use', acceptedUserAgreement);

        if (imageBack !== undefined && imageBack !== null) {
            formData.append('card_image_back', dataURLtoBlob(imageBack));
        }

        const startTime = new Date().getTime();


        cookie.remove('iceRequestToken', { secure: true });

        const fetchPromise = fetch(url.format({
            protocol: apiUrl.protocol,
            host: apiUrl.host,
            pathname: '/card-extraction/v1/card',
        }), {
            method: 'POST',
            credentials: 'same-origin',
            body: formData,
        });

        return Promise.all([
            fetchPromise,
        ])
            .then(response => response[0].json())
            .then(json => {
                dispatch(requestScanCardSucceeded(json, startTime));
                dispatch(recordNumberOfCarriersDisplayed(json));
            })
            .catch(reason => dispatch(requestScanCardFailed(reason, startTime)));
    };
}

export function capturedFrontInsuranceCard() {
    return {
        type: SCAN_CARD_CAPTURED_FRONT_CARD,
    };
}

function logDatadogMetric(getState, startTime, status) {
    const endTime = new Date().getTime();
    const timeMs = endTime - startTime;

    const state = getState();
    const apiUrl = getApiUrl(state);

    fetch(url.format({
        protocol: apiUrl.protocol,
        host: apiUrl.host,
        pathname: '/metrics/v1/monitoring',
    }), {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            events: [
                {
                    name: 'insurance_card_extraction.client.predict_time',
                    type: 'histogram',
                    value: timeMs,
                    tags: [
                        `status:${status}`,
                    ],
                },
            ],
        }),
    // eslint-disable-next-line no-console
    }).catch(err => console.error(err));
}

function requestScanCardSucceeded(response, startTime) {
    return (dispatch, getState) => {
        const state = getState();
        const dropdownState = dropdownStateSelector(state);

        logDatadogMetric(getState, startTime, 'ok');

        if (response.correlation_id) {
            cookie.set('iceRequestToken', response.correlation_id, { secure: true });
        }

        return dispatch({
            meta: {
                analytics: {
                    category: dropdownState.gaCategory,
                    action: 'Insurance Picker Scan - Card Captured',
                    type: AnalyticsTypes.TrackEvent,
                },
            },
            payload: {
                response,
            },
            type: REQUEST_SCAN_CARD_SUCCEEDED,
        });
    };
}

export function requestScanCardFailed(reason, startTime) {
    return (dispatch, getState) => {
        logDatadogMetric(getState, startTime, 'failed');

        const state = getState();
        const dropdownState = dropdownStateSelector(state);

        // close it first so we don't render the empty state
        closeScanCard('request scan card failed')(dispatch, getState);

        dispatch({
            meta: {
                analytics: {
                    action: 'Insurance Picker Scan - Card Upload Failed',
                    category: dropdownState.gaCategory,
                    type: AnalyticsTypes.TrackEvent,
                },
            },
            payload: {
                error: `${reason}`, // for debugging
            },
            type: REQUEST_SCAN_CARD_FAILED,
        });

        dispatch(setShowScanCardErrorModal(true));
    };
}

export function closeDropDownAndClearCard() {
    return (dispatch, getState) => {
        const state = getState();
        const dropdownState = dropdownStateSelector(state);

        // close the dropdown first so we don't re-render a weird state
        closeDropdown()(dispatch, getState);

        return dispatch({
            meta: {
                analytics: {
                    action: 'Insurance Picker Scan - Close Scan Card',
                    category: dropdownState.gaCategory,
                    options: {
                        label: 'x in top right',
                    },
                    type: AnalyticsTypes.TrackEvent,
                },
            },
            type: REQUEST_SCAN_CARD_CANCELLED,
        });
    };
}

const dispatchEditEvent = ({ type, action }) =>
    (dispatch, getState) => {
        const state = getState();
        const dropdownState = dropdownStateSelector(state);

        dispatch({
            type,
            meta: {
                analytics: {
                    action,
                    category: dropdownState.gaCategory,
                    type: AnalyticsTypes.TrackEvent,
                },
            },
        });
    };

export function editCarrier() {
    return dispatchEditEvent({
        type: EDIT_SCAN_CARD_CARRIER,
        action: 'Insurance Picker Scan - Clicked Edit Carrier',
    });
}

export function editPlan() {
    return dispatchEditEvent({
        type: EDIT_SCAN_CARD_PLAN,
        action: 'Insurance Picker Scan - Clicked Edit Plan',
    });
}

export function cancelEdit() {
    return dispatchEditEvent({
        type: CANCEL_EDIT_SCAN_CARD,
        action: 'Insurance Picker Scan - Canceled Edit',
    });
}

export function setScanCardCarrier(insurance, position) {
    return (dispatch, getState) => {
        invariant(insurance, 'insurance must be set');
        invariant(position, 'position must be set');

        const state = getState();
        const dropdownState = dropdownStateSelector(state);

        if (insurance.carrier.carrier_id === I_DONT_SEE_MY_CARRIER) {
            // enter into the normal picker flow
            closeScanCard('I don\'t see my carrier')(dispatch, getState);
            chooseCarrier()(dispatch, getState);

            return dispatch({
                meta: {
                    analytics: {
                        action: 'Insurance Picker Scan - Clicked I Don\'t See Carrier',
                        category: dropdownState.gaCategory,
                        type: AnalyticsTypes.TrackEvent,
                    },
                },
                type: REQUEST_SCAN_CARD_CANCELLED,
            });
        } else {
            return dispatch({
                meta: {
                    analytics: {
                        action: 'Insurance Picker Scan - Carrier Selected',
                        category: dropdownState.gaCategory,
                        options: {
                            label: position,
                        },
                        type: AnalyticsTypes.TrackEvent,
                    },
                },
                payload: {
                    insurance,
                    position,
                },
                type: SCAN_CARD_CHOOSE_CARRIER,
            });
        }
    };
}

export function clickBackToCarrier() {
    return {
        type: SCAN_CARD_REPICK_CARRIER,
    };
}

export function clickPlan(plan, position, shouldClosePicker = true) {
    return (dispatch, getState) => {
        const state = getState();
        const cardState = getScanCardState(state);
        const selections = getCarrierAndPlan(cardState);
        const selectedCarrier = selections.carrier;
        const dropdownState = dropdownStateSelector(state);

        invariant(plan, 'plan must be set');
        invariant(plan.hasOwnProperty('plan_id'), 'plan must have a plan_id');
        invariant(plan.hasOwnProperty('plan_name'), 'plan must have a plan_name');
        invariant(selectedCarrier, 'selectedCarrier must be set in the state');
        invariant(position, 'position must be set');

        const carrierDtoToUpdatePicker = {
            id: selectedCarrier.carrier_id,
            name: selectedCarrier.carrier_name,
        };

        if (plan.plan_id === I_DONT_SEE_MY_PLAN) {
            // close the card scan view
            // and dispatch a normal carrier selection event
            // to bring us back into the normal picker flow
            closeScanCard('I don\'t see my plan')(dispatch, getState);
            chooseCarrier(carrierDtoToUpdatePicker)(dispatch, getState);

            dispatch({
                meta: {
                    analytics: {
                        action: 'Insurance Picker Scan - Clicked I Don\'t See Plan',
                        category: dropdownState.gaCategory,
                        type: AnalyticsTypes.TrackEvent,
                    },
                },
                type: REQUEST_SCAN_CARD_CANCELLED,
            });
        } else {
            const planDtoToUpdatePicker = {
                id: plan.plan_id,
                name: plan.plan_name,
            };

            dispatch({
                payload: {
                    position,
                    plan,
                    insurance: selections.prediction,
                },
                type: SCAN_CARD_CHOOSE_PLAN,
            });

            if (shouldClosePicker) {
                chooseCarrier(carrierDtoToUpdatePicker)(dispatch, getState);
                choosePlan(planDtoToUpdatePicker, carrierDtoToUpdatePicker)(dispatch, getState);
                closeDropdown()(dispatch, getState);
            }

            dispatch({
                meta: {
                    analytics: {
                        action: 'Insurance Picker Scan - Plan Selected',
                        category: dropdownState.gaCategory,
                        options: {
                            label: position,
                        },
                        type: AnalyticsTypes.TrackEvent,
                    },
                },
                type: shouldClosePicker ? REQUEST_SCAN_CARD_DONE : SCAN_CARD_PLAN_SELECTED_V2,
            });
        }
    };
}

export function selectFirstCarrierAndPlan() {
    return (dispatch, getState) => {
        const state = getState();
        const cardState = getScanCardState(state);
        const { carrier, plan, prediction } = getCarrierAndPlan(cardState);

        if (carrier && plan) {
            if (!cardState.selectedInsurance) {
                dispatch({
                    payload: {
                        insurance: prediction,
                        position: 1,
                        autoSelectCarrier: true,
                    },
                    type: SCAN_CARD_CHOOSE_CARRIER,
                });
            }

            if (!cardState.selectedPlan) {
                dispatch({
                    payload: {
                        position: 1,
                        plan,
                        insurance: prediction,
                        autoSelectPlan: true,
                    },
                    type: SCAN_CARD_CHOOSE_PLAN,
                });
            }
        }
    };
}

export function clickContinue() {
    return (dispatch, getState) => {
        const state = getState();
        const cardState = getScanCardState(state);
        const { carrier, plan } = getCarrierAndPlan(cardState);
        const dropdownState = dropdownStateSelector(state);

        if (carrier && plan) {
            const carrierDto = {
                id: carrier.carrier_id,
                name: carrier.carrier_name,
            };

            const planDto = {
                id: plan.plan_id,
                name: plan.plan_name,
            };

            chooseCarrier(carrierDto)(dispatch, getState);
            choosePlan(planDto, carrierDto)(dispatch, getState);
            closeDropdown()(dispatch, getState);

            dispatch({
                meta: {
                    analytics: {
                        action: 'Insurance Picker Scan - Clicked Continue',
                        category: dropdownState.gaCategory,
                        type: AnalyticsTypes.TrackEvent,
                    },
                },
                type: REQUEST_SCAN_CARD_DONE,
            });
        }
    };
}

export function privacyCheckboxClicked() {
    return (dispatch, getState) => {
        const state = getState();
        const dropdownState = dropdownStateSelector(state);

        return dispatch({
            type: PRIVACY_CHECKBOX_CLICKED,
            meta: {
                analytics: {
                    action: 'Insurance Picker Scan - Privacy Checkbox Toggled',
                    category: dropdownState.gaCategory,
                    type: AnalyticsTypes.TrackEvent,
                },
            },
        });
    };
}

export function dismissPrivacyDialog() {
    return (dispatch, getState) => {
        const state = getState();
        const dropdownState = dropdownStateSelector(state);

        return dispatch({
            type: PRIVACY_DIALOG_DISMISS,
            meta: {
                analytics: {
                    action: 'Insurance Picker Scan - Privacy Dialog Dismissed',
                    category: dropdownState.gaCategory,
                    type: AnalyticsTypes.TrackEvent,
                },
            },
        });
    };
}

export function recordNumberOfCarriersDisplayed(apiResponse) {
    invariant(apiResponse.insurances, 'carriers must be set');

    return (dispatch, getState) => {
        const state = getState();
        const dropdownState = dropdownStateSelector(state);

        return dispatch({
            type: RECORD_NUMBER_OF_CARRIERS_DISPLAYED,
            meta: {
                analytics: {
                    action: 'Insurance Picker Scan - Showed Carriers',
                    category: dropdownState.gaCategory,
                    options: {
                        label: apiResponse.insurances.length,
                    },
                    type: AnalyticsTypes.TrackEvent,
                },
            },
        });
    };
}

export function recordNumberOfPlansDisplayed(plans) {
    invariant(plans, 'plans must be set');

    return (dispatch, getState) => {
        const state = getState();
        const dropdownState = dropdownStateSelector(state);

        return dispatch({
            type: RECORD_NUMBER_OF_PLANS_DISPLAYED,
            meta: {
                analytics: {
                    action: 'Insurance Picker Scan - Showed Plans',
                    category: dropdownState.gaCategory,
                    options: {
                        label: plans.length,
                    },
                    type: AnalyticsTypes.TrackEvent,
                },
            },
        });
    };
}
